import React from 'react';

function Publication(props) {
    return (
        <li>{props.author} ({props.date}). <em>{props.title}</em> {props.conference}
            <br/>
            <p className="text-justify">
                <small><strong>Abstract:</strong>
                    {props.abstract}
                </small> [ <a href={props.pdf}>PDF</a> ]
            </p>
        </li>
    )
}

export default Publication;